<template>
  <div id="addTask">
    <div class="cont">
      <div class="title">新建任务</div>
      <div class="steps">
        <el-steps :active="active" finish-status="success">
          <el-step title="第一步"></el-step>
          <el-step title="第二步"></el-step>
        </el-steps>
        <div class="button" @click="next" v-if="active === 0">下一步</div>
        <div class="button" @click="prev" v-if="active === 1">返回上一步</div>
      </div>
      <!-- 第一步筛选 -->
      <div style="margin-top: 10px; font-size: 14px;" v-if="active === 0">
        <div>
          <el-table :data="tableData2" style="width: 100%">
            <el-table-column prop="name" label="客户姓名" width="180"></el-table-column>
            <el-table-column prop="mobile" label="手机号" width="180"></el-table-column>
            <el-table-column prop="sd" label="类型">
              <template slot-scope="scope">
                <span v-if="scope.row.userSource === 0">双签用户</span>
                <span v-else>注册用户</span>
              </template>
            </el-table-column>
            <el-table-column label="操作" width="120">
              <template slot-scope="scope">
                <el-button @click.native.prevent="deleteRow(scope.$index, tableData2)" type="text" size="small"> <span style="color: #f00;">删除</span></el-button>
              </template>
            </el-table-column>
          </el-table>
          <div class="pagination">
            <el-pagination
              @size-change="sizeChange"
              @current-change="handleCurrentChange"
              :current-page.sync="currentPage"
              :page-sizes="[10,20,30,40]"
              :page-size="searchParams.pageSize"
              layout="total, sizes, prev, pager, next, jumper"
              :total="totalResult"
            ></el-pagination>
          </div>
        </div>
      </div>
      <!-- 第二步提交 -->
      <div style="margin-top: 10px; font-size: 14px;" v-else-if="active === 1">
        <el-form
          :model="dynamicValidateForm"
          ref="ruleForm"
          label-width="180px"
          class="demo-ruleForm"
        >
          <el-form-item label="任务名称：" style="width: 550px;" prop="name" required>
            <el-input v-model="dynamicValidateForm.name" placeholder="请输入任务名称" style="width: 370px;"></el-input>
          </el-form-item>
          <el-form-item label="任务时间：" style="width: 550px;" required>
            <el-date-picker
              v-model="dynamicValidateForm.CreatTime"
              type="datetimerange"
              range-separator="至"
              start-placeholder="请输入开始时间"
              end-placeholder="请输入结束时间"
              style=" width: 370px"
              :picker-options="pickerOptions"
              value-format="yyyy-MM-dd HH:mm:ss"
              :default-time="['00:00:00', '23:59:59']"
              @change="setParams"
            ></el-date-picker>
          </el-form-item>
          <el-form-item
            label="选择执行客服："
            style="width: 550px;"
            v-for="(domain, index) in dynamicValidateForm.domains"
            :key="domain.key"
            :prop="'domains.' + index + '.value'"
            required
          >
            <el-select v-model="domain.value" @change="checkUser($event)" style="width: 315px;" placeholder="请选择执行客服的工号">
              <el-option :label="item" :value="item" v-for="item in listMan" :key="item.name"></el-option>
            </el-select>
            <el-button v-if="index > 0" @click.prevent="removeDomain(domain)">删除</el-button>
          </el-form-item>
          <el-button style="margin-left: 180px;" @click="addDomain">+ 选择执行客服的工号</el-button>
          <el-form-item class="bottomBtn">
            <!-- <el-button @click="resetForm('ruleForm')">重置</el-button> -->
            <el-button
              type="primary"
              @click="submitForm('ruleForm')"
              style="width:150px; margin: 0px atuo; "
            >提交</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
  </div>
</template>
<script>
// import { devCode, baseUrl } from '@/http/baseUrl';
export default {
  name: 'myClient',
  data () {
    return {
      active: 0,
      searchParams: {
        table: '',
        pageSize: 10,
        pageIndex: 0
      },
      currentPage: 1,
      totalResult: 0,
      totalPage: 0,
      fromType: '',
      tableData: [],
      tableData2: [],
      AllTableData: [],
      listMan: [],
      dynamicValidateForm: {
        domains: [
          {
            value: '',
            kfID: ''
          }
        ],
        name: '',
        CreatTime: []
      },
      pickerOptions: {
        disabledDate (time) {
          return time.getTime() < Date.now() - 8.64e7;
        }
      },
      // rules: {
      //   name: [
      //     { required: true, message: '请输入任务名称', trigger: 'blur' },
      //     { min: 1, max: 30, message: '长度在 1 到 30 个字符', trigger: 'blur' }
      //   ],
      //   domains: [
      //     { required: true, message: '请选择执行客服的工号', trigger: 'change' }
      //   ],
      //   CreatTime: [
      //     {
      //       type: 'date',
      //       required: true,
      //       message: '请设置任务时间',
      //       trigger: 'change'
      //     }
      //   ]
      // },
      arrt: []
    };
  },
  watch: {
  },
  computed: {},
  created () {
    if (this.$route.query.fromUrl === 'order') {
      this.fromType = 1;
    } else if (this.$route.query.fromUrl === 'cilent') {
      this.fromType = 1;
    } else if (this.$route.query.fromUrl === 'jianhangUser') {
      this.fromType = 0;
    }
    this.tableData = this.$route.query.table;
    this.totalResult = this.$route.query.table.length;
    this.totalPage = (this.$route.query.table.length / 10);
    this.getList();
    this.getListMan();
  },
  methods: {
    getList () {
      // 请求所有列表
      this.axios
        .get(`/doubleTask/clientList`, {
          params: {
            mobiles: this.tableData,
            pageIndex: this.searchParams.pageIndex,
            pageSize: this.searchParams.pageSize,
            userSource: this.fromType
          }
        })
        .then(res => {
          if (res.data.isSuccess) {
            let myData = res.data.resultData;
            let newMyData = myData.pageListData.slice(this.searchParams.pageIndex, this.searchParams.pageSize);
            this.AllTableData = myData.pageListData; // 获取全部数据然后单独处理分页
            this.tableData2 = newMyData; // 默认当前页数据
            this.totalResult = res.data.resultData.totalResult;
            this.totalPage = Math.ceil(myData.pageListData.length / this.searchParams.pageSize);
          } else {
            this.$message.warning(res.data.message);
            this.totalResult = 0;
            this.totalPage = 0;
          }
        });
    },
    // 获取管家列表
    getListMan (e) {
      this.axios
        .get(`/member/getManagerWorkNumber`, {
          params: {}
        })
        .then(res => {
          if (res.data.ok) {
            this.listMan = res.data.data;
          }
        });
    },
    next () {
      let obj = '';
      obj = this.tableData2.find(item => {
        return item.kf5UserId;
      });
      if (obj) {
        if (this.active++ > 1) this.active = 0;
      } else {
        this.$message.warning('缺少逸创id不能进行下一步');
      }
    },
    prev () {
      if (this.active++ > 0) this.active = 0;
    },
    resetForm (formName) {
      this.$refs[formName].resetFields();
    },
    addDomain () {
      // + 执行客服工号选择
      this.dynamicValidateForm.domains.push({
        value: '',
        kfID: '',
        key: Date.now()
      });
    },
    checkUser (value) {
      // 选择框
      var arr = this.dynamicValidateForm.domains;
      console.log(arr);
      var map = {};
      for (var i = 0; i < arr.length; i++) {
        var val = arr[i].value;
        if (!map[val]) {
          map[val] = 1;
        } else {
          map[val]++;
        }
      }
      for (var k in map) {
        // console.log(k + '在数组中出现的次数为' + map[k]);
        if (map[k] > 1) {
          this.$message.warning('执行客户工号不能重复');
          for (var c = 0; c < arr.length; c++) {
            var b = arr.length;
            arr[b - 1].value = '';
          }
        } else {
          var arrt = this.arrt;
          arrt = this.dynamicValidateForm.domains;
          console.log(arrt);
          for (let i = 0; i < arrt.length; i++) {
            this.axios({
              url: `/doubleTask/mangerList`,
              method: 'get',
              params: {
                bindWorknumber: arrt[i].value
              }
            }).then(res => {
              if (res.data.resultData) {
                console.log(res.data.resultData[0].kf5UserId);
                if (!res.data.resultData[0].kf5UserId) {
                  this.$message.error('未查询到逸创客服ID，请先关联逸创客服ID！');
                  arrt[i].value = '';
                } else {
                  arrt[i].kfID = res.data.resultData[0].kf5UserId;
                }
              } else {
                this.$message.error(res.data.message);
              }
            });
          }
        }
      }
      // this.axios({
      //   url: `/doubleTask/mangerList`,
      //   method: 'get',
      //   params: {
      //     bindWorknumber: value
      //   }
      // }).then(res => {
      //   if (res.data.resultData) {
      //     // console.log(res.data.resultData[0].kf5UserId)
      //     obj.value = res.data.resultData[0].kf5UserId
      //     console.log(obj)
      //     setTimeout(function(){
      //        arrB.push(obj)
      //     },400)
      //   } else {
      //     this.$message.error(res.data.message);
      //   }
      // })
    },
    removeDomain (item) {
      console.log(item);
      var index = this.dynamicValidateForm.domains.indexOf(item);
      if (index !== -1) {
        this.dynamicValidateForm.domains.splice(index, 1);
      }
    },
    setParams (curVal) {
      console.log('时间', curVal);
      this.dynamicValidateForm.domains.CreatTime = curVal;
    },
    sizeChange (val) { // 设置每页多少条
      this.searchParams.pageSize = val;
      this.searchParams.pageIndex = 0;
      this.totalPage = Math.ceil(this.AllTableData.length / this.searchParams.pageSize);
      this.tableData2 = this.AllTableData.slice(this.searchParams.pageIndex, this.searchParams.pageSize);
      // this.getList();
      this.currentPage = 1;
    },
    handleCurrentChange (val) {
      console.log('点击页码', val);
      this.searchParams.pageIndex = val - 1;
      let nowPageSize = (this.searchParams.pageSize * val) - (this.searchParams.pageSize); // 当前页的条数起 0 10 20 30
      let netPageSize = this.searchParams.pageSize * val; // 当前页的条数结束 10 20 30 40
      this.totalPage = Math.ceil(this.AllTableData.length / this.searchParams.pageSize);
      this.tableData2 = this.AllTableData.slice(nowPageSize, netPageSize); // 起止条数算法（末端条数减去一页条数）至（一页条数乘以页码）
      // this.getList();
    },
    GetDateStr (AddDayCount) {
      var dd = new Date();
      dd.setDate(dd.getDate() + AddDayCount); // 获取AddDayCount天后的日期
      var y = dd.getFullYear();
      var m = dd.getMonth() + 1; // 获取当前月份的日期
      var d = dd.getDate();
      return y + '-' + m + '-' + d;
    },
    submitForm (formName) {
      var date = new Date();
      var today = this.GetDateStr(0);
      var hour = date.getHours();
      var fen = date.getMinutes();
      // var currentdate = year + '-' + month + '-' + day + ' ' + hour + ':' + fen + ':' + miao;
      var currentdate = today + ' ' + hour + ':' + fen;
      // 提交表单内容两个集合
      if (
        this.dynamicValidateForm.name === '' ||
        this.dynamicValidateForm.domains === '' ||
        !this.dynamicValidateForm.domains.CreatTime
      ) {
        this.$confirm('请确认完善全部信息后提交', '提示', {
          confirmButtonText: '确定',
          center: true,
          type: 'warning'
        });
      } else {
        let item = [];
        let item2 = [];
        let item3 = [];
        let obj = '';
        let obj2 = '';
        let obj3 = '';
        this.AllTableData.forEach(item => {
          obj += item.mobile + ',';
        });
        this.dynamicValidateForm.domains.forEach(item => {
          obj2 += item.kfID + ',';
        });
        this.dynamicValidateForm.domains.forEach(item => {
          obj3 += item.value + ',';
        });
        item = obj.substring(0, obj.length - 1);
        item2 = obj2.substring(0, obj2.length - 1);
        item3 = obj3.substring(0, obj3.length - 1);
        let formData = {
          taskDetailName: this.dynamicValidateForm.name,
          startTime: this.dynamicValidateForm.domains.CreatTime[0],
          endTime: this.dynamicValidateForm.domains.CreatTime[1],
          taskPhones: item,
          kf5Ids: item2, // 关联管家工号
          bindWorkNumbers: item3, // 选中管家工号
          creatAt: currentdate, // 系统创建时间
          userSource: this.fromType
        };
        this.axios.post(`/doubleTask/operaionTask`, formData).then(res => {
          if (res.data.isSuccess) {
            this.$message.success(res.data.message);
            this.$router.push({name: 'isTruetask'});
          } else {
            this.$message.error(res.data.message);
          }
        });
      }
    },
    deleteRow (index, rows) {
      this.$confirm('确定要移除吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          rows.splice(index, 1);
          this.AllTableData.splice(index, 1);
          this.totalResult = (this.totalResult - 1);
          this.totalPage = Math.ceil(this.totalResult / this.searchParams.pageSize);
          this.AllTableData = this.AllTableData;
          let newVal = ''; // 自定义页码
          if (this.searchParams.pageIndex > 0) { // 有多于1页的数据
            newVal = this.searchParams.pageIndex + 1;
            this.totalPage = Math.ceil(this.AllTableData.length / this.searchParams.pageSize);
            console.log('1111+++++', this.totalPage, newVal);
            if (this.totalPage === newVal) { // 仍在当前页删除
              let nowPageSize = (this.searchParams.pageSize * newVal) - (this.searchParams.pageSize); // 当前页的条数起 0 10 20 30
              let netPageSize = this.searchParams.pageSize * newVal; // 当前页的条数结束 10 20 30 40
              this.tableData2 = this.AllTableData.slice(nowPageSize, netPageSize); // 起止条数算法（末端条数减去一页条数）至（一页条数乘以页码）
            } else if (this.totalPage < newVal) { // 已经删掉一页
              let nowPageSize = (this.searchParams.pageSize * this.totalPage) - (this.searchParams.pageSize); // 当前页的条数起 0 10 20 30
              let netPageSize = this.searchParams.pageSize * this.totalPage; // 当前页的条数结束 10 20 30 40
              this.tableData2 = this.AllTableData.slice(nowPageSize, netPageSize); // 起止条数算法（末端条数减去一页条数）至（一页条数乘以页码）
            }
          } else { // 只有一页
            newVal = this.searchParams.pageIndex;
            this.totalPage = Math.ceil(this.AllTableData.length / this.searchParams.pageSize);
            this.tableData2 = this.AllTableData.slice(0, 10); // 起止条数算法（末端条数减去一页条数）至（一页条数乘以页码）
          }
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消操作'
          });
        });
    }
  }
};
</script>
  <style>
  .el-step.is-horizontal .el-step__line { top: 20px; }
.cont {
  width: 90%;
  margin: 0 auto;
  padding: 50px 50px;
  display: flex;
  align-items: center;
  flex-direction: column;
}
.cont .title {
  font-size: 16px;
  font-weight: 550;
  line-height: 50px;
}
.cont .steps {
  display: flex;
  width: 50%;
  justify-content: center;
}
.el-steps,
.el-steps--horizontal {
  width: 30%;
  margin: 0px auto;
}
.el-step__icon,
.is-text {
  width: 40px;
  height: 40px;
}
.cont .button {
  background: #2eb3f8;
  padding: 0px 55px;
  border-radius: 5px 5px;
  font-size: 14px;
  color: #fff;
  height: 40px;
  cursor: pointer;
  line-height: 40px;
  text-align: center;
}
.cont .bottomBtn {
  margin-top: 20px;display:flex;justify-content:center;
}
</style>



// WEBPACK FOOTER //
// src/components/taskManage/addTask.vue